import { ref } from 'vue';

const scrollWidth = ref(0); 

const lockScroll = () => {
  const body = document.body;
  scrollWidth.value = window.innerWidth - document.documentElement.clientWidth;

  body.style.maxWidth = '100vw';
  body.style.maxHeight = '100dvh';
  body.style.overflow = 'hidden';
  body.style.paddingRight = `${scrollWidth.value}px`;
};

const unlockScroll = () => {
  const body = document.body;
  body.style.maxWidth = '';
  body.style.maxHeight = '';
  body.style.overflow = '';
  body.style.paddingRight = '';
};

export function useGlobalScrollLock() {
  return {
    lockScroll,
    unlockScroll,
    scrollWidth
  };
}